import { HABIT_PAR_DEFAUT, type FormeDeBulle, type TraitDeProjet } from '@nextilt/commun';
import { estUnObjet, SilhouetteDObjet } from './objetsDeBulle';
import './ApercuDeForme.css';

/**
 * Une petite bulle dans l'une des vingt-deux formes (chantier habit-du-projet, ticket 03 ; les
 * quatorze objets, chantier habit-des-bulles, modification 02), au trait de son contour (ticket
 * 04) : l'aperçu d'un choix, dans le panneau « Habit » d'un projet, dans Paramètres et dans
 * l'habit d'une bulle. Elle est dessinée par les mêmes feuilles que les bulles de la Carte
 * (`styles/bulles/*.css`, la classe `bulle-d-apercu[data-forme]` sous `.forme-de-projet` et
 * `.trait-de-projet[data-trait]` ; un objet, par `SilhouetteDObjet` et `objets.css`) : aucun
 * dessin recopié. Sans trait dit, celui d'un projet neuf.
 */
export function ApercuDeForme({
  forme,
  trait = HABIT_PAR_DEFAUT.trait,
  grand = false,
  petit = false,
}: {
  forme: FormeDeBulle;
  trait?: TraitDeProjet;
  grand?: boolean;
  /** En tout petit, la grille des formes de l'habit d'une bulle (chantier habit-des-bulles, 04, `.fr-formes`). */
  petit?: boolean;
}) {
  const objet = estUnObjet(forme) ? forme : null;
  return (
    <span
      className={`apercu-de-forme forme-de-projet trait-de-projet${grand ? ' apercu-de-forme--grand' : ''}${petit ? ' apercu-de-forme--petit' : ''}`}
      data-forme={objet ? undefined : forme}
      data-trait={trait}
      aria-hidden="true"
    >
      <span className="bulle-d-apercu" data-forme={objet ? undefined : forme} data-objet={objet ?? undefined}>
        {objet && <SilhouetteDObjet objet={objet} />}
      </span>
    </span>
  );
}
